import React, { useEffect, useState, useRef } from "react";
import { StarOutlined, UploadOutlined } from "@ant-design/icons";

import { App, Button, Form, Upload } from "antd";
/**
 * 文件名需要将url转义  同时去除服务端生成随机串
 * 服务端的文件格式为fileName: `${Math.floor(random*10)}_${timestamp}_${encodeURI(原始文件名)}`
 * @param url
 * @returns
 */
const getFileNameByUrl = (url) => {
  const mainUrl = url.split("?")[0];
  const fileName = mainUrl.split("/").pop();
  let realFileName = decodeURIComponent(fileName);
  const fileNameArray = realFileName.split("_");
  if (fileNameArray.length >= 3) {
    realFileName = fileNameArray.slice(2).join("_");
  }
  return realFileName;
};

// 根据url对象 获取文件对象, 上传中状态 url是对象
const getFileObject = (url, uid) => {
  if (typeof url !== "string" || !url) return url;
  const mainUrl = url.split("?")[0];
  const fileName = getFileNameByUrl(url);
  return {
    name: fileName,
    url: mainUrl,
    downloadUrl: url,
    thumbUrl: url,
    uid: uid || url,
    key: uid || url,
  };
};

/**
 * 将url数组转换成组件识别的文件数组 value格式, 数组长度一一对应
 * {
 *  url:['xxx','xxx'],
 *  downloadUrl: ['xxx','xxx']
 * }
 *
 * 将value 和 onChange 格式 做转换 {url: [], downloadUrl: []} <-> [{url:url1, name:'xxx'},{url:url2, name:'xxx'}]
 * [{
 *  name: '文件名',// 必填
 *  url: '文件路径',// 必填
 *  downloadUrl: '下载地址',
 *  size: 123,
 *  status: 'sucess'
 *  uid
 * }]
 */
const transformArrayTOObjectArray = (list = []) => {
  const result = {
    realList: [],
    uid: [],
    key: [],
  };
  if (Array.isArray(list)) {
    result.realList = list || [];
  } else if (typeof list === "object") {
    const { downloadUrl, url = [], uid = [], key = [] } = list || {};
    result.realList = downloadUrl || url;
    result.uid = uid;
    result.key = key;
  } else if (typeof list === "string") {
    result.realList.push(list);
    // result.uid = uid;
    // result.key = key;
  }

  return result.realList.map((item, index) => {
    const uid = result.uid[index] || result.key[index];
    return getFileObject(item, uid || "");
  });
};

const OSSUpload = ({
  value,
  onChange: _onChange,
  defaultHost = "https://planogram-prod.oss-ap-southeast-1.aliyuncs.com",
  ...resetProps
}) => {
  // const { message } = App.useApp();

  const ossDataMapRef = useRef({});
  // const [OSSData, setOSSData] = useState();
  // const [fileList, setFileList] = useState([]);
  // const [currentFileUid, setCurrentFileUid] = useState();
  const curFileId = useRef();

  const [_value, set_Value] = useState(value);
  // 默认附初始值
  useEffect(() => {
    // 如果是编辑状态图片不是数组处理成数组格式
    if (value) {
      if (Array.isArray(value)) {
        set_Value(value);
      } else {
        set_Value([value]);
        _onChange && _onChange([value]);
      }
    }
  }, [value]);

  //   获取OSS凭证
  const getOssConfig = async (file) => {
    try {
      const { name, uid } = file;
      const res = await fetch(
        `/base/api/v1/fs/direct-upload-sign?sceneCode=attachment&fileName=${
          name || uid
        }`
      ).then((res) => res.json());
      // return Promise.resolve(mockData);
      if (res.success) {
        return res?.data || {};
      } else {
        throw new Error(res.message);
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  const onChangeAdaptor = (args) => {
    const { file: cFile, fileList } = args;
    const realFiles = fileList
      .map((file) => {
        const { status, uid, key, response, url } = file || {};
        const realUrl = url || response?.url;
        if (["done", "success", "error"].includes(status)) {
          if (status === "error") {
            return null;
          }
          return {
            url: realUrl?.split("?")[0],
            downloadUrl: realUrl,
            uid,
            key,
          };
        }
        return null;
      })
      .filter(Boolean);

    const result = realFiles.reduce(
      (total, item) => {
        const { url, downloadUrl, uid } = item;
        if (url || downloadUrl) {
          total.url.push(url);
          total.downloadUrl.push(downloadUrl);
          total.uid.push(uid);
        } else {
          total.url.push(item);
          total.downloadUrl.push(item);
          total.uid.push(item);
        }
        return total;
      },
      {
        url: [],
        downloadUrl: [],
        uid: [],
        key: [],
      }
    );

    // 出去只出去url数组
    _onChange && _onChange(result.url, cFile, fileList);
    set_Value(result.url);
  };

  const onSuccessAdaptor = (args, file) => {
    const { url } = file;

    const curFiles = Array.isArray(_value) ? [..._value, url] : [url];

    // 出去只出去url数组
    _onChange && _onChange(curFiles);
    set_Value(curFiles);
  };

  const onRemove = (file) => {
    const files = Array.isArray(_value)
      ? _value.filter((v) => !v?.includes(file.url))
      : [];

    _onChange && _onChange?.(files);
    set_Value(files);
  };

  const getExtraData = (file) => {
    const { url, ossConfig = {}, uid } = file;
    // console.log("ossConfig", ossDataMapRef.current?.[uid]);
    return (
      ossDataMapRef.current?.[uid] || {
        key: uid,
        OSSAccessKeyId: ossConfig?.accessId,
        policy: ossConfig?.policy,
        Signature: ossConfig?.signature,
      }
    );
  };

  const beforeUpload = async (_file, fileList) => {
    try {
      let tempFile = _file;
      curFileId.current = _file.uid;
      // setCurrentFileUid(_file.uid);

      const data = await getOssConfig(tempFile);
      // setOSSData(data);
      ossDataMapRef.current[_file.uid] = data;

      // const expire = Number(data.expire) * 1000;

      // if (expire < Date.now()) {
      //   await getOssConfig(tempFile);
      // }

      const suffix = tempFile.name.slice(tempFile.name.lastIndexOf("."));

      tempFile.url = data.url;
      tempFile.ossConfig = data;
      return tempFile;
    } catch (error) {
      if (onError) onError(error, null, _file);
      throw error;
    }
  };

  /** 文件上传结束后会调用该函数 */
  const formatter = (_, _file) => {
    if (!_file?.uid) return undefined;
    const temp = ossDataMapRef.current[_file.uid];
    // eslint-disable-next-line no-param-reassign
    _file.key = temp.key;
    delete ossDataMapRef.current[_file.uid];
    return temp;
  };

  const uploadProps = {
    // name: "file",
    listType: "picture",

    ...resetProps,

    // defaultFileList: fileList,
    defaultFileList: transformArrayTOObjectArray(_value),
    fileList: transformArrayTOObjectArray(_value),
    // fileList,
    value: transformArrayTOObjectArray(_value),

    action: curFileId.current
      ? ossDataMapRef.current[curFileId.current]?.host
      : defaultHost,
    onChange: onChangeAdaptor,
    onSuccess: onSuccessAdaptor,

    onRemove,
    data: getExtraData,
    beforeUpload,
    // formatter,
    showUploadList: {
      // extra: ({ size = 0 }) => (
      //   <span style={{ color: "#cccccc" }}>
      //     ({(size / 1024 / 1024).toFixed(2)}MB)
      //   </span>
      // ),
      showDownloadIcon: true,
      downloadIcon: "Download",
      //   showRemoveIcon: true,
      //   removeIcon: (
      //     <StarOutlined
      //       onClick={(e) => console.log(e, "custom removeIcon event")}
      //     />
      //   ),
    },
  };

  // console.log("&&&&&", uploadProps, ossDataMapRef);
  return (
    <Upload {...uploadProps}>
      <Button icon={<UploadOutlined />}>Click to Upload</Button>
    </Upload>
  );
};

export default OSSUpload;
